function attachVideoPause(swiper) {
  if (!swiper) return;

  const pauseAllExceptActive = () => {
    const root = swiper.el;
    if (!root) return;

    // pausa tudo
    root.querySelectorAll("video").forEach(v => {
      try { v.pause(); } catch (e) {}
    });

    // deixa tocar só os vídeos dentro do slide ativo
    const active = root.querySelector(".swiper-slide-active");
    if (active) {
      active.querySelectorAll("video").forEach(v => {
        // não dar play automático — só não pausa.
        // se você quiser dar play automático, descomenta abaixo:
        // try { v.play(); } catch (e) {}
      });
    }
  };

  // Quando troca de aba / minimiza (Safari/Chrome)
document.addEventListener("visibilitychange", () => {
  if (document.hidden) pauseAllVideos();
});

// Quando navega pra fora / refresh / fecha (best-effort)
window.addEventListener("pagehide", () => pauseAllVideos());
window.addEventListener("beforeunload", () => pauseAllVideos());

// (opcional) se você usa SPA e muda rota por pushState:
window.addEventListener("popstate", () => pauseAllVideos());

  // roda já na init
  swiper.on("init", pauseAllExceptActive);

  // eventos “normais”
  swiper.on("slideChange", pauseAllExceptActive);
  swiper.on("transitionStart", pauseAllExceptActive);
  swiper.on("transitionEnd", pauseAllExceptActive);

  // eventos que pegam cssMode/trackpad melhor
  swiper.on("setTranslate", pauseAllExceptActive);
  swiper.on("touchStart", pauseAllExceptActive);
  swiper.on("sliderMove", pauseAllExceptActive);

  // cssMode usa scroll real: então escuta o scroll do wrapper
  if (swiper.params.cssMode && swiper.wrapperEl) {
    swiper.wrapperEl.addEventListener("scroll", pauseAllExceptActive, { passive: true });
  }

  // garante que init rode
  if (!swiper.initialized) swiper.init();
}


// THUMBS
const thumbsSwiper = new Swiper(".mySwiper", {
  spaceBetween: 8,
  slidesPerView: "auto",
  freeMode: true,
  watchSlidesProgress: true,
  direction: window.matchMedia("(min-width: 1024px)").matches ? "vertical" : "horizontal",
  mousewheel: {
    forceToAxis: true,
    sensitivity: 0.6,
    releaseOnEdges: true,
    thresholdDelta: 2,
  },
});

// MAIN (ligado nas thumbs)
const mainSwiper = new Swiper(".mySwiper2", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: { swiper: thumbsSwiper },

  // se quiser cssMode, ok — mas não duplique mousewheel
  cssMode: true,
  mousewheel: {
    forceToAxis: true,
    sensitivity: 0.4,
    releaseOnEdges: true,
    thresholdDelta: 2,
  },
});

attachVideoPause(mainSwiper);

// Mantém direção correta se redimensionar
window.addEventListener("resize", () => {
  const newDir = window.matchMedia("(min-width: 1024px)").matches ? "vertical" : "horizontal";
  if (thumbsSwiper.params.direction !== newDir) thumbsSwiper.changeDirection(newDir);
});

let modalSwiper;

function openGallery(index = 0) {
  const modal = document.getElementById("galleryModal");
  if (!modal) return;

  modal.classList.remove("hidden");

  if (!modalSwiper) {
    modalSwiper = new Swiper(".modalSwiper", {
      initialSlide: index,
      spaceBetween: 8,
       navigation: {
        nextEl: ".swiper-button-next.galleryModal",
        prevEl: ".swiper-button-prev.galleryModal",
      },
      slidesPerView: 1,
      cssMode: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 0.4,
        releaseOnEdges: true,
        thresholdDelta: 2,
      },
    });

    attachVideoPause(modalSwiper);
  } else {
    modalSwiper.slideTo(index, 0);
  }

  document.body.style.overflow = "hidden";
}

function pauseAllVideos(scope) {
  (scope || document).querySelectorAll("video").forEach(v => {
    try { v.pause(); } catch (e) {}
  });
}

function closeGallery() {
  const modal = document.getElementById("galleryModal");
  if (!modal) return;

  pauseAllVideos(modal);
  modal.classList.add("hidden");
  document.body.style.overflow = "";
}

// Botão X
const closeBtn = document.getElementById("closeGallery");
if (closeBtn) closeBtn.onclick = closeGallery;

// Fechar clicando fora
const backdrop = document.querySelector("[data-modal-backdrop]");
if (backdrop) backdrop.addEventListener("click", closeGallery);

// Fechar com ESC
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") closeGallery();
});

// MODAL: NÃO ABRIR QUANDO CLICAR NO VÍDEO
document.querySelectorAll(".mySwiper2 .swiper-slide").forEach((slide, index) => {
  slide.addEventListener("click", (e) => {
    if (e.target.closest("video")) return;
    openGallery(index);
  });
});

// Também impede clique do vídeo de “subir”
document.querySelectorAll(".mySwiper2 video").forEach((video) => {
  video.addEventListener("click", (e) => e.stopPropagation());
});

